import { useAppState } from 'hooks/useAppState';
import { PartnerManager } from 'types/partnerManager';

export const usePartnerManager = (): PartnerManager => {
  const { partnerManager } = useAppState();

  return partnerManager;
};
